import _module from 'module.js'

const VIEW_CONTACT_CENTER_CONFIGURATION = 'cc-config';

export default class ContactCenterConfigurationService {
  constructor (portalApi) {
    'ngInject'
    this.portalApi = portalApi
  }

  getUserContext(pbxUUID) {
    return this.portalApi.contactCenterAuthority.pbxs(pbxUUID).userContext().get()
  }

  hasContactCenterConfigurationPermission(context) {
    return context && context.permissions && context.permissions.includes(VIEW_CONTACT_CENTER_CONFIGURATION)
  }
}

_module
  .service('contactCenterConfigurationService', ContactCenterConfigurationService)
